export default class SellAgency {

    constructor($view) {
        this.$view = $view;
        this.bind();
    }

    bind(){

        window.addEventListener("load", function(event) {
            if (window.screen.width<767)
            {
                $("#responsiveonly").addClass('show');
                $("#desktoponly").removeClass('show');
            }else{
                $("#responsiveonly").removeClass('show');
                $("#desktoponly").addClass('show');
            }

        });

        // on resize
        window.addEventListener("resize", function(){

            if (window.screen.width<767)
            {
                $("#responsiveonly").addClass('show');
                $("#desktoponly").removeClass('show');
            }else{
                $("#responsiveonly").removeClass('show');
                $("#desktoponly").addClass('show');
            }

        });

        // on ajout un event sur le code postal
        $("#codepostal").keyup(function (e){
            var resultInput =e.target.value;
            $.ajax( {
                url: "/cities/search",
                data: {
                    autocomplete: resultInput,
                    format: 2,
                    name: 'ville',
                    id:'ville'
                },
                success: function(data) {
                    $("#second-ville-container").html(data.html);
                    $("#ville").select2();
                },
                error: function(){

                },
            });
        });

    }
}